import { BenefitData, BENEFITS } from "../screens/BenefitsV3";

export const getBenefitsByTitle = (title: typeof BENEFITS[number]["title"]) => {
  return BENEFITS.find(benefit => title === benefit.title) as BenefitData;
};
